import React, { useState } from 'react';
import avatar from '../../uploads/avatar.png';
import { Select } from 'antd';
const { PhoneNumberUtil, PhoneNumberFormat } = require('google-libphonenumber');

const PersonalInfo = ({ formData, setFormData }) => {
  
  const [showPassportModal, setShowPassportModal] = useState(false);
  const [showWorkPhoneNumberModal, setShowWorkPhoneNumberModal] = useState(false);
  const [showBirthPlaceModal, setShowBirthPlaceModal] = useState(false);
  const [workPhone, setWorkPhone] = useState('');
  const imageUrl = formData.Photo ? `data:image/jpeg;base64, ${formData.Photo}` : avatar;
  let birthPlace = `${formData.BirthPlace.Country}, ${formData.BirthPlace.City}`;

  const handleChange = (event, option) => {
    const { name, value, dataset } = typeof event === "string" ? option : event.target;
    const { parent } = dataset;
    if (parent) {
      if (name === "extNumber") {
        setFormData(prevState => ({
          ...prevState,
          [parent]: {
            ...prevState[parent],
            [name]: value,
            value: `${workPhone}, доб. ${value}`
          }
        }));
      } else {
        setFormData(prevState => ({
          ...prevState,
          [parent]: {
            ...prevState[parent],
            [name]: value
          }
        }));
      }
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };
  const handlePhoneChange = (event, isWorkPhone) => {
    if(isWorkPhone) {
      const { value } = event.target;
      let numberValue = extractNumberFormat(value);
      let formattedNumber = numberValue === '' ? value : numberValue
      setWorkPhone(formattedNumber);
      if(formData.WorkPhoneNumber.extNumber.length > 0) formData.WorkPhoneNumber.value = `${formattedNumber}, доб. ${formData.WorkPhoneNumber.extNumber}`;
      else formData.WorkPhoneNumber.value = `${formattedNumber}, доб. ${formData.WorkPhoneNumber.extNumber}`;
    } else {
      const { name, value, dataset } = event.target;
      const { parent } = dataset;
      let numberValue = extractNumberFormat(value);
      if (parent) {
        setFormData(prevState => ({
          ...prevState,
          [parent]: {
            ...prevState[parent],
            [name]: numberValue === '' ? value : numberValue
          }
        }));
      } else {
        setFormData(prevState => ({
          ...prevState,
          [name]: numberValue === '' ? value : numberValue
        }));
      }
    }
  };
  
  const loadImage = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
        const base64String = event.target.result.split(',')[1];
        setFormData(prevState => {
            const updatedState = {
                ...prevState,
                Photo: base64String
            };
            return updatedState;
        });
    };
    reader.readAsDataURL(file);
  };
  
  const handlePassportClear = () => {  
      setShowPassportModal(false);
  };

  const extractNumberFormat = (number) => {
		const phoneUtil = PhoneNumberUtil.getInstance();
		let phoneNumber = '';
		try {
		const parsedPhoneNumber = phoneUtil.parseAndKeepRawInput(number, 'ZZ');
		const formattedPhoneNumber = phoneUtil.format(parsedPhoneNumber, PhoneNumberFormat.RFC3966);
		const cleanedPhoneNumber = formattedPhoneNumber.replace('tel:', '');
        const parts = cleanedPhoneNumber.split('-');
		phoneNumber = '';
		for(let i = 0; i < parts.length; i++) {
			if(i < 2) phoneNumber += `${parts[i]} `
			else phoneNumber += `${parts[i]}`
		}
		return phoneNumber;
		} catch (error) {
			return '';
		}
	}

  return (
    <div>
      <table>
        <tbody>
          <tr>
            <th colSpan="3" className="bg">
              <p>Ф.И.О.</p>
              <input
                type="text"
                name="Name"
                style={{width: "50%"}}
                value={formData.Name}
                onChange={handleChange}
              />
            </th>
          </tr>
          <tr>
            <td width="35%">
              <p className="title">Дата рождения:</p>
              <input
                type="date"
                name="BirthDate"
                value={formData.BirthDate}
                onChange={handleChange}
              />
            </td>
            <td width="45%">
              <p className="title">Место рождения:</p>
              <p style={{ margin: "0 10px" }}>{birthPlace.length > 2 ? birthPlace : ""}</p><button type="button" className='btn' onClick={() => setShowBirthPlaceModal(true)}>Заполнить данные</button>
            </td>
            <td width="20%" rowSpan="6">
              <div style={{ margin: '0 auto', width: '70%' }}>
                <label htmlFor="avatar">
                  <img id="avatar-img" src={imageUrl} width="100%" height="100%" alt="" />
                </label>
                <input
                  id="avatar"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  hidden
                  onChange={loadImage}
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <p className="title">Национальность:</p>              
              <Select
                value={formData.Nationality.Name ? formData.Nationality.Name : undefined}
                onChange={handleChange}
                showSearch
                style={{ width: 200 }}
                placeholder="Выберите национальность"
                optionFilterProp="children"
                filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
                notFoundContent={"Нет данных"}
                options={[
                  {
                    value: 'Каракалпак',
                    label: 'Каракалпак',
                    name: "Name",
                    dataset: {
                      parent: "Nationality"
                    }
                  },
                  {
                    value: 'Каракалпачка',
                    label: 'Каракалпачка',
                    name: "Name",
                    dataset: {
                      parent: "Nationality"
                    }
                  },
                  {
                    value: 'Русский',
                    label: 'Русский',
                    name: "Name",
                    dataset: {
                      parent: "Nationality"
                    }
                  },
                  {
                    value: 'Русская',
                    label: 'Русская',
                    name: "Name",
                    dataset: {
                      parent: "Nationality"
                    }
                  },
                  {
                    value: 'Узбек',
                    label: 'Узбек',
                    name: "Name",
                    dataset: {
                      parent: "Nationality"
                    }
                  },
                  {
                    value: 'Узбечка',
                    label: 'Узбечка',
                    name: "Name",
                    dataset: {
                      parent: "Nationality"
                    }
                  },
                ]}
              />
            </td>
            <td>
              <p className="title">Гражданство:</p>
              <Select
                value={formData.Citizenship.Name ? formData.Citizenship.Name : undefined}
                onChange={handleChange}
                showSearch
                style={{ width: 200 }}
                optionFilterProp="children"
                filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
                placeholder="Выберите гражданство"
                notFoundContent={"Нет данных"}
                options={[
                  {
                    value: 'Россия',
                    label: 'Россия',
                    name: "Name",
                    dataset: {
                      parent: "Citizenship"
                    }
                  },
                  {
                    value: 'Узбекистан',
                    label: 'Узбекистан',
                    name: "Name",
                    dataset: {
                      parent: "Citizenship"
                    }
                  },
                  {
                    value: 'Казахстан',
                    label: 'Казахстан',
                    name: "Name",
                    dataset: {
                      parent: "Citizenship"
                    }
                  },
                  {
                    value: 'Киргизия',
                    label: 'Киргизия',
                    name: "Name",
                    dataset: {
                      parent: "Citizenship"
                    }
                  },
                  {
                    value: 'Таджикистан',
                    label: 'Таджикистан',
                    name: "Name",
                    dataset: {
                      parent: "Citizenship"
                    }
                  },
                ]}
              />
            </td>
          </tr>
          <tr>
            <td><p className="title">Пол:</p></td>
            <td>
            <Select
                value={formData.Sex ? formData.Sex : undefined}
                onChange={handleChange}
                style={{ width: 200 }}
                placeholder="Выберите пол"
                options={[
                  {
                    value: 'Мужской',
                    label: 'Мужской',
                    name: "Sex",
                    dataset: {}
                  },
                  {
                    value: 'Женский',
                    label: 'Женский',
                    name: "Sex",
                    dataset: {}
                  },
                ]}
              />
            </td>
          </tr>
          <tr>
            <td><p className="title">Паспортные данные:</p></td>
            <td><p style={{ marginRight: "10px" }}>{`${formData.Passport.type} ${formData.Passport.DocSeries} ${formData.Passport.DocNumber} ${formData.Passport.DocDateIssued}`}</p><button type="button" className='btn' onClick={() => setShowPassportModal(true)}>Заполнить данные</button></td>
          </tr>
          <tr>
            <td><p className="title">Семейное положение:</p></td>
            <td>
              <select
                data-parent="MaritalStatus"
                name="Name"
                value={formData.MaritalStatus.Name}
                onChange={handleChange}
                style={{ border: 'none' }}
              >
                <option value="" disabled>Выберите семейное положение</option>
                <option value="Холост/Не замужем">Холост/Не замужем</option>
                <option value="Женат/Замужем">Женат/Замужем</option>
                <option value="Разведен/Разведена">Разведен/Разведена</option>
                <option value="Вдовец/Вдова">Вдовец/Вдова</option>
                <option value="Никогда не состоял(а) в браке">Никогда не состоял(а) в браке</option>
                <option value="Состоит в незарегистрированном браке">Состоит в незарегистрированном браке</option>
              </select>
            </td>
          </tr>          
        </tbody>
      </table>
      <table style={{ marginTop: '-1px' }}>
        <tbody>
          <tr>
            <td width='20%'><p className="title">Email (рабочий):</p></td>
            <td width='30%'><input type="email" name="EmailWork" value={formData.EmailWork} onChange={handleChange} /></td>
            <td width='20%'><p className="title">Email (личный):</p></td>
            <td width='30%'><input type="email" name="EmailPersonal" value={formData.EmailPersonal} onChange={handleChange} /></td>
          </tr>         
        </tbody>
      </table>
      <table style={{ marginTop: '-1px' }}>
        <tbody>
          <tr>
            <td width='20%'><p className="title">ИНН:</p></td>
            <td width='30%'><input type="text" name="INN" value={formData.INN} onChange={handleChange} /></td>
            <td width='20%'><p className="title">ИНПС:</p></td>
            <td width='30%'><input type="text" name="INPS" value={formData.INPS} onChange={handleChange} /></td>
          </tr>         
        </tbody>
      </table>
      <table style={{ marginTop: '-1px' }}>
        <tbody>
          <tr>
            <td width='40%'><p className="title">Телефон (мобильный, служебный):</p></td>
            <td><input type="text" data-parent="MobilePhoneWork" name="value" value={formData.MobilePhoneWork.value} onChange={handlePhoneChange} style={{ width: "100%" }} /></td>
          </tr>         
          <tr>
            <td width='40%'><p className="title">Телефон (мобильный, личный):</p></td>
            <td><input type="text" data-parent="MobilePhonePersonal" name="value" value={formData.MobilePhonePersonal.value} onChange={handlePhoneChange} style={{ width: "100%" }} /></td>
          </tr>         
          <tr>
            <td width='40%'><p className="title">Телефон (домашний):</p></td>
            <td><input type="text" data-parent="HomePhoneNumber" name="value" value={formData.HomePhoneNumber.value} onChange={handlePhoneChange} style={{ width: "100%" }} /></td>
          </tr>         
          <tr>
            <td width='40%'><p className="title">Телефон (служебный):</p></td>
            <td><p style={{ marginRight: "10px" }}>{formData.WorkPhoneNumber.value.length > 10 ? formData.WorkPhoneNumber.value : ''}</p><button type="button" className='btn' onClick={() => setShowWorkPhoneNumberModal(true)}>Заполнить данные</button></td>
          </tr>         
        </tbody>
      </table>
      {showPassportModal && (
        <>
        <div className="modal-bg" onClick={handlePassportClear}></div>
        <div className="modal">
          <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Паспортные данные</h4><button className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={handlePassportClear} >X</button>
          <table>
            <tbody>
              <tr>
                <td width='40%'><p className="title">Вид документа:</p></td>
                <td width='60%'>
                  <select data-parent="Passport" name="type" value={formData.Passport.type} onChange={handleChange}>
                    <option value="" disabled>Выберите вид документа</option>
                    <option value="Паспорт гражданина РУз">Паспорт гражданина РУз</option>
                    <option value="Паспорт иностранного граждана">Паспорт иностранного граждана</option>
                    <option value="ID карта гражданина РУз">ID карта гражданина РУз</option>
                  </select>  
                </td>
              </tr>  
              <tr>
                <td width='40%'><p className="title">Серия документа:</p></td>
                <td width='60%'>
                  <input type="text" data-parent="Passport" name="DocSeries" value={formData.Passport.DocSeries} onChange={handleChange} />
                </td>
              </tr>      
              <tr>
                <td width='40%'><p className="title">Номер документа:</p></td>
                <td width='60%'>
                  <input type="text" data-parent="Passport" name="DocNumber" value={formData.Passport.DocNumber} onChange={handleChange} />
                </td>
              </tr>      
              <tr>
                <td width='40%'><p className="title">Кем выдан:</p></td>
                <td width='60%'>
                  <input type="text" data-parent="Passport" name="DocIssued" value={formData.Passport.DocIssued} onChange={handleChange} />
                </td>
              </tr>      
              <tr>
                <td width='40%'><p className="title">Дата выдачи:</p></td>
                <td width='60%'>
                  <input type="date" data-parent="Passport" name="DocDateIssued" value={formData.Passport.DocDateIssued} onChange={handleChange} />
                </td>
              </tr>      
              <tr>
                <td width='40%'><p className="title">Код департамента:</p></td>
                <td width='60%'>
                  <input type="text" data-parent="Passport" name="departmentCode" value={formData.Passport.departmentCode} onChange={handleChange} />
                </td>
              </tr>      
              <tr>
                <td width='40%'><p className="title">Срок действия:</p></td>
                <td width='60%'>
                  <input type="date" data-parent="Passport" name="DocValid" value={formData.Passport.DocValid} onChange={handleChange} />
                </td>
              </tr>      
              <tr>
                <td width='40%'><p className="title">Сведения о документе действует с:</p></td>
                <td width='60%'>
                  <input type="date" data-parent="Passport" name="DocInfoValid" value={formData.Passport.DocInfoValid} onChange={handleChange} />
                </td>
              </tr>     
            </tbody>
          </table>
          <div style={{ marginTop: "32px" }}></div>
          <button className='btn' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={() => setShowPassportModal(false)} >ОК</button>
        </div>
        </>
      )}
      {showWorkPhoneNumberModal && (
        <>
        <div className="modal-bg" onClick={() => setShowWorkPhoneNumberModal(false)}></div>
        <div className="modal">
          <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Домашний телефон</h4><button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => setShowWorkPhoneNumberModal(false)} >X</button>
          <table>
            <tbody>       
              <tr>
                <td width='40%'><p className="title">Номер:</p></td>
                <td width='60%'>
                  <input type="text" data-parent="WorkPhoneNumber" name="Number" value={workPhone} onChange={(event) => handlePhoneChange(event, true)}  />
                </td>
              </tr>        
              <tr>
                <td width='40%'><p className="title">Добавочный номер:</p></td>
                <td width='60%'>
                  <input type="number" data-parent="WorkPhoneNumber" name="extNumber" value={formData.WorkPhoneNumber.extNumber} onChange={handleChange} />
                </td>
              </tr>        
              <tr>
                <td width='40%'><p className="title">Представление:</p></td>
                <td width='60%'>
                  <input type="text" data-parent="WorkPhoneNumber" name="value" value={formData.WorkPhoneNumber.value.length > 10 ? formData.WorkPhoneNumber.value : ''} onChange={handleChange} style={{ width: "100%" }} />
                </td>
              </tr>        
            </tbody>
          </table>
          <div style={{ marginTop: "32px" }}></div>
          <button className='btn' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={() => setShowWorkPhoneNumberModal(false)} >ОК</button>
        </div>
        </>
      )}
      {showBirthPlaceModal && (
        <>
        <div className="modal-bg" onClick={() => setShowBirthPlaceModal(false)}></div>
        <div className="modal">
          <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Место рождения</h4><button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => setShowBirthPlaceModal(false)} >X</button>
          <table>
            <tbody> 
              <tr>
                <td width='40%'><p className="title">Страна:</p></td>
                <td width='60%'>
                  <input type="text" data-parent="BirthPlace" name="Country" value={formData.BirthPlace.Country} onChange={handleChange} />
                </td>
              </tr>         
              <tr>
                <td width='40%'><p className="title">Город:</p></td>
                <td width='60%'>
                  <input type="text" data-parent="BirthPlace" name="City" value={formData.BirthPlace.City} onChange={handleChange} />
                </td>
              </tr>         
            </tbody>
          </table>
          <div style={{ marginTop: "32px" }}></div>
          <button className='btn' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={() => setShowBirthPlaceModal(false)} >ОК</button>
        </div>
        </>
      )}
    </div>
  );
};

export default PersonalInfo;
